<template>
  <div>
    <div id="header_content_left">
      <div class="title">走进中磊</div>
      <div class="list">
       <li v-for="(item, index) in categoryList" :key="index" >
        <router-link v-if="item.id!==5&&item.id!==7&&item.id!==8" :to="{ path: '/about', query: { category_id: item.id }}" :class="{ current: isActive(item.id) || item.id==$route.query.category_id }"
        @click.native="selectCategory(item.id)" @mouseover="hoverCategory(item.id)" @mouseout="unhoverCategory">
        {{ item.title }}
      </router-link>
      <router-link v-else-if="item.id==5" :to="{ path: '/honor', query: { category_id: item.id }}" :class="{ current: isActive(item.id) || item.id==$route.query.category_id }"
        @click.native="selectCategory(item.id)" @mouseover="hoverCategory(item.id)" @mouseout="unhoverCategory">
        {{ item.title }}
      </router-link>
      <router-link v-else-if="item.id==7" :to="{ path: '/partner', query: { category_id: item.id }}" :class="{ current: isActive(item.id) || item.id==$route.query.category_id }"
        @click.native="selectCategory(item.id)" @mouseover="hoverCategory(item.id)" @mouseout="unhoverCategory">
        {{ item.title }}
      </router-link>
      <router-link v-else :to="{ path: '/video', query: { category_id: item.id }}" :class="{ current: isActive(item.id) || item.id==$route.query.category_id }"
        @click.native="selectCategory(item.id)" @mouseover="hoverCategory(item.id)" @mouseout="unhoverCategory">
        {{ item.title }}
      </router-link>
       </li>
      </div>
      <div class="banner"><img src="@/assets/images/banner.jpg"></div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeCategoryId: null,
        hoveredCategoryId: null
      }
    },
    watch: {
    '$route.query.category_id'(newId) {
      this.activeCategoryId = newId;
    }
  },
    mounted() {
      if (this.categoryList.length > 0) {
        // this.activeCategoryId = this.categoryList[0].id; // 设置第一个分类为默认激活状态
      }
    },
    methods: {
      selectCategory(id) {
        this.activeCategoryId = id;
      },
      hoverCategory(id) {
        this.hoveredCategoryId = id;
      },
      unhoverCategory() {
        this.hoveredCategoryId = null;
      },
      isActive(id) {
        return this.activeCategoryId === id || this.hoveredCategoryId === id;
      }
    },
    props: ['categoryList']
  }
</script>

<style>

</style>